import React from "react";

const Footer = () => {
    return(
        <footer className="bg-color1 text-white py-6">
            <div className="container mx-auto text-center">
                <p className="text-sm mb-0">&copy; {new Date().getFullYear()} Muhammad Rafa. all right reserved</p>
            </div>
        </footer>
    )
}

export default Footer;